import React from 'react';
import { useTranslation } from 'react-i18next';
import { CheckCircleRounded } from '@mui/icons-material';
import { SCREEN_TYPE } from '@src/constants';
import { REQUEST_STATUS } from '@src/constants/voice';
import CircularProcess from '@src/components/CircularProcess';
import useRequestAnimationStatus from '@src/hooks/useRequestAnimationStatus';
import { StyledChip, StyledLinearStatus } from './index.style';

const END_POINT = 99;
const SWAP_POINT = 50;

const RequestStatus = ({ request, screenType, marginLeft }) => {
  const { t } = useTranslation();

  const { displayProgress, displayStatus } = useRequestAnimationStatus(request);
  const requestStatus = REQUEST_STATUS;
  if (displayStatus === 'SUCCESS') {
    return <></>;
  }
  if (!request.id) return <></>;

  if (screenType === SCREEN_TYPE.MOBILE) {
    return (
      <>
        {displayStatus === requestStatus.SUCCESS && (
          <CheckCircleRounded color="success" />
        )}
        {displayStatus === requestStatus.FAILURE && (
          <CheckCircleRounded color="error" />
        )}
        {displayStatus === requestStatus.DRAFT && (
          <CheckCircleRounded color="info" />
        )}
        {displayStatus === requestStatus.IN_PROGRESS && (
          <CircularProcess value={displayProgress} size={28} thickness={6} />
        )}
      </>
    );
  }

  return (
    <>
      {displayStatus === requestStatus.SUCCESS && (
        <StyledChip color="success">{t(requestStatus.SUCCESS)}</StyledChip>
      )}
      {displayStatus === requestStatus.FAILURE && (
        <StyledChip color="error">{t(requestStatus.FAILURE)}</StyledChip>
      )}
      {displayStatus === requestStatus.DRAFT && (
        <StyledChip color="info">{t(requestStatus.DRAFT)}</StyledChip>
      )}
      {displayStatus === requestStatus.IN_PROGRESS && (
        <StyledLinearStatus
          color="info"
          progress={Math.max(displayProgress, END_POINT - displayProgress)}
          toright={displayProgress > SWAP_POINT}
          marginLeft={marginLeft}
        >
          {displayProgress}%
        </StyledLinearStatus>
      )}
    </>
  );
};

export default RequestStatus;
